import { render, staticRenderFns } from "./salida-formulario.vue?vue&type=template&id=5d1e265a"
import script from "./salida-formulario.vue?vue&type=script&lang=js"
export * from "./salida-formulario.vue?vue&type=script&lang=js"
import style0 from "./salida-formulario.vue?vue&type=style&index=0&id=5d1e265a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports